import { z } from 'zod';
import { auditFieldsSchema, idSchema, paginated, paginationQuerySchema } from './common.js';
/**
 * Categoria genérica com escopo. Evita uma tabela de categoria por módulo:
 * material de obra, despesa e documento compartilham a mesma estrutura.
 */
export const CATEGORY_SCOPES = ['ITEM', 'PESSOA', 'FINANCEIRO', 'DOCUMENTO'];
export const categoryScopeSchema = z.enum(CATEGORY_SCOPES);
export const CATEGORY_SCOPE_LABELS = {
    ITEM: 'Itens e materiais',
    PESSOA: 'Pessoas',
    FINANCEIRO: 'Financeiro',
    DOCUMENTO: 'Documentos',
};
export const categorySchema = auditFieldsSchema.extend({
    id: idSchema,
    companyId: idSchema,
    scope: categoryScopeSchema,
    name: z.string(),
    description: z.string().nullable(),
    parentId: idSchema.nullable(),
    isActive: z.boolean(),
});
export const categoryInputSchema = z.object({
    scope: categoryScopeSchema,
    name: z.string().trim().min(2, 'Informe o nome').max(120),
    description: z.string().trim().max(500).optional().nullable(),
    parentId: idSchema.optional().nullable(),
    isActive: z.boolean().default(true),
});
export const categoryListQuerySchema = paginationQuerySchema.extend({
    scope: categoryScopeSchema.optional(),
});
export const categoryListResponseSchema = paginated(categorySchema);
//# sourceMappingURL=category.js.map